/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useState } from 'react';

import ChipMenuDialog from '../../../components/ChipMenuDialog/ChipMenuDialog';
import { customName, premixName } from './NewSeedTypeButton';
import { MenuEntry } from './SeedMixMenu';
import { Button } from '../../../components/Button';
import TestIds from '../../../testIds';

export const AddPaddockMenu = ({
  onAddPremix,
  onAddCustom,
}: {
  onAddPremix: () => void;
  onAddCustom: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const addPremix = () => {
    setOpen(false);
    onAddPremix();
  };
  const addCustom = () => {
    setOpen(false);
    onAddCustom();
  };

  return (
    <>
      <Button
        variant='outlined'
        onClick={handleClick}
        data-testid={TestIds.feat.seedOrders.footer.addAnotherPaddock}
      >
        Add another paddock
      </Button>
      <ChipMenuDialog
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        paperSx={{ padding: 0 }}
      >
        <MenuEntry
          onClick={addPremix}
          label={`${premixName} order`}
          data-testid={TestIds.feat.seedOrders.footer.addAnotherPaddockPremix}
        />
        <MenuEntry
          onClick={addCustom}
          label={`${customName} order`}
          data-testid={TestIds.feat.seedOrders.footer.addAnotherPaddockCustom}
        />
      </ChipMenuDialog>
    </>
  );
};
